class AccountExtraitTransaction {
  transactionId: string;
  description: string;
  status: string;
  type: string;
  cancelledDate: string;
  executedDate: string;
  transactionDate: string;
  transactionValueDate: string;
  transactionUnit: number;
  transactionUser: string;
  transactionUserSerialNumber: number;
  amount: number;
  counterparty: string;
  paymentDetails: string;
  balance: number;
  currency: string;
  disabled: boolean;

  constructor(
    transactionId: string,
    description: string,
    status: string,
    type: string,
    cancelledDate: string,
    executedDate: string,
    transactionDate: string,
    transactionValueDate: string,
    transactionUnit: number,
    transactionUser: string,
    transactionUserSerialNumber: number,
    amount: number,
    counterparty: string,
    paymentDetails: string,
    balance: number,
    currency: string,
  ) {
    this.transactionId = transactionId;
    this.description = description;
    this.status = status;
    this.type = type;
    this.cancelledDate = cancelledDate;
    this.executedDate = executedDate;
    this.transactionDate = transactionDate;
    this.transactionValueDate = transactionValueDate;
    this.transactionUnit = transactionUnit;
    this.transactionUser = transactionUser;
    this.transactionUserSerialNumber = transactionUserSerialNumber;
    this.amount = amount;
    this.counterparty = counterparty;
    this.paymentDetails = paymentDetails;
    this.balance = balance;
    this.currency = currency;
    this.disabled = !Boolean(this.transactionId);
  }
}

export { AccountExtraitTransaction };
